import styled from 'styled-components'

export const SelectError = styled.div`
  ${({ theme }) => theme.textSizes.desktop.placeholderS}
  color: #f5083e;
  margin-top: ${({ theme }) => theme.spacing(0.5)};
`
